import { DynamicStandaloneBreakingNews } from '@/components/BreakingNews';
import { LabradorComponent } from '@/types/component';

const LabradorBreakingNews: LabradorComponent = ({ data }) => {
  return <DynamicStandaloneBreakingNews articles={data.articles} />;
};

export default LabradorBreakingNews;
